"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELoadingStatus = void 0;
var ELoadingStatus;
(function (ELoadingStatus) {
    ELoadingStatus["idle"] = "idle";
    ELoadingStatus["loading"] = "loading";
    ELoadingStatus["loaded"] = "loaded";
    ELoadingStatus["error"] = "error";
})(ELoadingStatus || (exports.ELoadingStatus = ELoadingStatus = {}));
